/**
 * 로그인 체크 유틸리티
 * - 로그인이 필요한 링크 클릭 시 체크 및 리디렉션 처리
 */

/**
 * 로그인 상태 확인
 * @returns {boolean} - 로그인 여부
 */
export function isLoggedIn() {
  return window.isLoggedIn === true || document.body.classList.contains("is-logged-in");
}

/**
 * 로그인 필요 링크 클릭 핸들러
 * @param {Event} e - 클릭 이벤트
 * @param {string} loginUrl - 로그인 페이지 URL (기본값: '/auth/login')
 * @param {string} message - 확인 메시지 (기본값: '로그인이 필요합니다. 로그인 페이지로 이동하시겠습니까?')
 * @returns {boolean} - 이벤트 전파 여부 (false면 preventDefault)
 */
export function handleRequireLoginClick(e, loginUrl = "/auth/login", message = "로그인이 필요합니다. 로그인 페이지로 이동하시겠습니까?") {
  if (isLoggedIn()) {
    return true; // 로그인되어 있으면 정상 진행
  }

  e.preventDefault();
  e.stopPropagation();

  if (confirm(message)) {
    window.location.href = loginUrl;
  }

  return false;
}

/**
 * 로그인 필요 링크 초기화
 * @param {string} selector - 선택자 (기본값: '[data-require-login="true"]')
 * @param {string} loginUrl - 로그인 페이지 URL (기본값: '/auth/login')
 * @param {string} message - 확인 메시지
 */
export function initRequireLoginLinks(selector = '[data-require-login="true"]', loginUrl = "/auth/login", message) {
  const links = document.querySelectorAll(selector);

  links.forEach((link) => {
    // 기존 이벤트 리스너 제거를 위해 클론 후 교체
    const newLink = link.cloneNode(true);
    link.parentNode.replaceChild(newLink, link);

    // 새로 이벤트 바인딩
    newLink.addEventListener("click", function (e) {
      handleRequireLoginClick(e, loginUrl, message);
    });
  });
}

/**
 * 동적으로 생성된 요소에도 로그인 체크 적용
 * @param {HTMLElement} container - 컨테이너 요소 (기본값: document)
 * @param {string} selector - 선택자 (기본값: '[data-require-login="true"]')
 * @param {string} loginUrl - 로그인 페이지 URL
 * @param {string} message - 확인 메시지
 */
export function bindRequireLoginToContainer(container = document, selector = '[data-require-login="true"]', loginUrl = "/auth/login", message) {
  const links = container.querySelectorAll(selector);

  links.forEach((link) => {
    // 이미 이벤트가 바인딩되어 있는지 확인
    if (link.dataset.loginBound === "true") {
      return;
    }

    link.dataset.loginBound = "true";
    link.addEventListener("click", function (e) {
      handleRequireLoginClick(e, loginUrl, message);
    });
  });
}

